import {
	VBtn,
	VDivider,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemAvatar,
	VListItemContent,
	VListItemTitle,
	VMenu,
	VListItemSubtitle,
	VSwitch
} from "vuetify/lib";
import KAvatar from "./KAvatar";

export default {
	name: "KAccountButton",

	computed: {
		dark: {
			get() {
				return this.$store.state.app.dark;
			},

			set( val ) {
				return this.$store.dispatch( "app/setDark", val );
			}
		},

		user() {
			return this.$store.getters["auth/user"];
		},

		userInitials() {
			return `${this.user.firstName.slice( 0, 1 )}${this.user.lastName.slice( 0, 1 )}`;
		},

		avatar() {
			return <KAvatar
				extractFirstLetter={false}
				size={40}
				text={this.userInitials}
				textSizeClass="text-subtitle-1"
			></KAvatar>;
		}
	},

	render() {
		return <VMenu
			bottom
			left
			offsetY
			scopedSlots={{
				activator: ( { on } ) =>
					<VBtn
						on={on}
						text
					>{this.avatar}</VBtn>
			}}
		>
			<VList subheader>
				<VListItem
					activeClass={this.dark ? "grey darken-4" : "grey lighten-2"}
					to={{ name: "account" }}
				>
					<VListItemAction>
						{this.avatar}
					</VListItemAction>

					<VListItemContent>
						<VListItemTitle>Hey, {this.user.firstName}!</VListItemTitle>
						<VListItemSubtitle class="link--text">Manage my account</VListItemSubtitle>
					</VListItemContent>
				</VListItem>

				<VDivider></VDivider>

				<VListItem onClick={() => this.dark = !this.dark}>
					<VListItemAction>
						<VSwitch
							color="accent"
							inset
							onClick={e => e.preventDefault()}
							vModel={this.dark}
						></VSwitch>
					</VListItemAction>

					<VListItemContent>
						<VListItemTitle>Dark Mode</VListItemTitle>
					</VListItemContent>
				</VListItem>

				<VListItem
					href="http://ksrticket.com"
					target="_blank"
				>
					<VListItemAvatar width={46}>
						<VIcon>help</VIcon>
					</VListItemAvatar>

					<VListItemContent>
						<VListItemTitle>IT Help Desk</VListItemTitle>
					</VListItemContent>
				</VListItem>

				<VListItem onClick={() => this.$store.dispatch( "auth/logout" )}>
					<VListItemAvatar width={46}>
						<VIcon>power_settings_new</VIcon>
					</VListItemAvatar>

					<VListItemContent>
						<VListItemTitle>Log Out</VListItemTitle>
					</VListItemContent>
				</VListItem>
			</VList>
		</VMenu>;
	}
};
